import {
  CalendarPlus,
  ClipboardList,
  FileText,
  Home,
  LayoutDashboard,
  UserRound,
  type LucideIcon,
} from 'lucide-react';

/*
 * The client portal's navigation, as data — the same shape as `admin-nav.ts`,
 * and it reuses that file's `isNavItemActive` rather than growing a second
 * matcher. P4 is one prefix-matching bug and it does not need two homes.
 *
 * Flat, not grouped. The admin sidebar has five groups because it has twenty
 * destinations; this has five, and a group label above every single item is
 * furniture rather than structure.
 */

export interface ClientNavItem {
  readonly label: string;
  readonly to: string;
  readonly icon: LucideIcon;
}

export const CLIENT_NAV: readonly ClientNavItem[] = [
  { label: 'Dashboard', to: '/portal', icon: LayoutDashboard },
  { label: 'My Cleans', to: '/portal/cleans', icon: ClipboardList },
  { label: 'Properties', to: '/portal/properties', icon: Home },
  // Phase 12.5 — what we have billed them, with the PDF and how to pay.
  { label: 'Invoices', to: '/portal/invoices', icon: FileText },
  { label: 'Request a Cleaning', to: '/portal/request', icon: CalendarPlus },
  { label: 'Profile', to: '/portal/profile', icon: UserRound },
];

/**
 * Honeycomb's public site.
 *
 * Today this is the live GoDaddy marketing site, which is what the apex still
 * serves — the app deploys to the bare IP until cutover (ROADMAP.md §1.2). The
 * link is written as the apex rather than as a GoDaddy URL precisely so that it
 * keeps working, unchanged, on the day phase 13 points that apex at our own
 * marketing pages.
 */
export const PUBLIC_SITE_URL = 'https://honeycombcleaning.com';
